export default {
  driver_performance_driver_moduleDrivers: "Conductores",
  driver_performance_driver_title: "Conductor",
  driver_performance_driver_name: "Nombre",
  driver_performance_driver_totalDistance: "Distancia Total",
  driver_performance_driver_overview: "Resumen",
  driver_performance_driver_detail_hideDescription: "Ocultar Descripción",
  driver_performance_driver_detail_showDescription: "Mostrar Descripción",
  driver_performance_driver_detail_supervisorName: "Supervisor",
  driver_performance_driver_detail_riskMatrix_eventName: "Nombre del Evento",
  driver_performance_driver_detail_riskMatrix_riskScore: "Puntuación de Riesgo",
  driver_performance_driver_detail_riskMatrix_avgSeverity: "Severidad Promedio",
  driver_performance_driver_detail_riskMatrix_avgEventCount: "Conteo Promedio de Eventos",
  driver_performance_driver_detail_riskMatrix_driverName: "Nombre del Conductor",
  driver_performance_driver_detail_risk: "Riesgo",
};
